import React, { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Confirm } from "semantic-ui-react";
import { useUnsavedChangesGuard, UnsavedChangesContext } from "../../hooks/useUnsavedChangesGuard";
import UnsavedChangesRoutePrompt from "./UnsavedChangesRoutePrompt";

const UnsavedChangesTabSection = forwardRef(({ activeKey, header, content, children }, ref) => {
    const [isDirty, setIsDirty] = useState(false);
    const { requestChange, isConfirmOpen, confirmChange, cancelChange } = useUnsavedChangesGuard(isDirty);

    useImperativeHandle(ref, () => ({ requestChange }), [requestChange]);

    useEffect(() => {
        setIsDirty(false);
    }, [activeKey]);

    return (
        <UnsavedChangesContext.Provider value={setIsDirty}>
            {children}
            <UnsavedChangesRoutePrompt isDirty={isDirty} header={header} content={content} />
            <Confirm
                open={isConfirmOpen}
                header={header}
                content={content}
                onCancel={cancelChange}
                onConfirm={confirmChange}
            />
        </UnsavedChangesContext.Provider>
    );
});

UnsavedChangesTabSection.displayName = "UnsavedChangesTabSection";

UnsavedChangesTabSection.propTypes = {
    activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    header: PropTypes.string,
    content: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default UnsavedChangesTabSection;
